
import { Component, Prop, Vue } from "vue-property-decorator";
import PModal from "@/components/look/PModal.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";
import { Getter } from "vuex-class";
import {
  IDeclaredValuePack,
  ISolCustomerCurrency,
  ISolCustomerPack,
  IUserDetailData,
  IValuePack,
} from "@/entities";
import DeclaredValuePackDetails from "@/components/orders/agile_pickup/DeclaredValuePackDetails.vue";
import { ISaveDeclaredValuePackRequestBody } from "@/services";

@Component({
  name: "add-edit-declared-value-pack-modal",
  components: {
    DeclaredValuePackDetails,
    Multiselect,
    PModal,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class AddEditDeclaredValuePackModal extends Vue {
  @Prop({ required: true }) packs!: ISolCustomerPack[];
  @Prop({ required: true, default: "", type: String }) serviceCode!: string;
  @Prop({ required: false, default: null }) declaredValue!: IDeclaredValuePack;

  @Getter("getLoggedUser") getLoggedUser!: IUserDetailData;
  @Getter("getSolCustomerCurrencies") currencies!: ISolCustomerCurrency[];

  public packSelected: ISolCustomerPack | null = null;
  public quantity: number | null = null;
  public declaredValues: IValuePack[] = [];
  $refs!: {
    formValuesPack: InstanceType<typeof ValidationObserver>;
  };
  private valueEdit: IValuePack | null = null;

  initData(): void {
    this.resetForm();
    this.declaredValues = [];
    this.declaredValues.push(...(this.declaredValue?.vl?.map((value) => ({ ...value })) || []));
  }

  resetForm(): void {
    this.valueEdit = null;

    this.packSelected = null;
    this.quantity = null;
    this.$refs.formValuesPack?.reset();
  }

  onEdit(value: IValuePack): void {
    this.packSelected = this.packs.find((p) => p.code === value.pc) ?? null;
    this.quantity = value.pq!;

    this.valueEdit = value;
  }

  onSubmit(): void {
    if (this.valueEdit) {
      this.valueEdit.cic = this.packSelected?.denominations?.[0]?.currencyIsoCode;
      this.valueEdit.pc = this.packSelected?.code;
      this.valueEdit.pq = Number(this.quantity);
    } else {
      const declaredValue = this.declaredValues.find((dv) => dv.pc === this.packSelected?.code);

      if (declaredValue) {
        declaredValue.pq = Number(declaredValue.pq) + Number(this.quantity);
      } else {
        this.declaredValues.push({
          cic: this.packSelected?.denominations?.[0]?.currencyIsoCode,
          pc: this.packSelected?.code,
          pq: Number(this.quantity),
        });
      }
    }

    this.resetForm();
  }

  hideModal(): void {
    this.$bvModal.hide("addEditDeclaredValuePackModal");
  }

  async onSave(): Promise<void> {
    const request: ISaveDeclaredValuePackRequestBody = {
      ct: this.getLoggedUser.country!.code!,
      svc: this.serviceCode,
      dr: [
        {
          co: this.declaredValue?.co,
          vl: this.declaredValues || [],
        },
      ],
    };

    let success: boolean;
    if (this.declaredValue) {
      success = await this.$services.solServiceApi.updateDeclaredValuePack(request);
    } else {
      success = await this.$services.solServiceApi.saveDeclaredValuePack(request);
    }

    if (success) {
      this.$emit("success");
      this.hideModal();
    }
  }
}
